import { Component, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APIService } from 'src/services/api-services/api-service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';

import { AdvisorsComponent } from '../../advisors.component';
import { HelperService } from 'src/services/helperService';
import { TranslateService } from '@ngx-translate/core';
import { AdvisorManagement, ManagementBrand, ServiceManagement } from 'src/models/workshopsManagement.interface';
import { Workshop } from 'src/models/workshop';
import { APIAdvisorService } from 'src/services/api-services/api-advisor-service';
import { advisorDTO } from 'src/services/api-services/api-interfaces/api-advisor.interface';
interface modalInformation{
  advisor: AdvisorManagement,
  workshop: Workshop[]
}
interface brandCreate {
  brandId: number,
  isActive: boolean
}
@Component({
    selector: 'app-edit-info1',
    templateUrl: './edit-info-advisor.dialog.html',
    styleUrls: ['./edit-info-advisor.dialog.sass'],
    standalone: false
})
export class EditInfoDialogadvisor {
  constructor(

    public dialogRef: MatDialogRef<AdvisorsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public modalInformation: modalInformation,
    public ServiceAdvisorApi: APIAdvisorService,
    public Service: APIService,
    public helperService: HelperService,
    private translate: TranslateService
  ) {

  }

  advisorName=this.modalInformation.advisor ? this.modalInformation.advisor.advisorName : ''
  workshopSelected: number = 0
  showError: boolean = false
  phoneNumber: string = this.modalInformation.advisor ? this.modalInformation.advisor.documentNumber : '';
  brandsSelected: number[] = this.modalInformation.advisor ?  this.modalInformation.advisor.brands.filter((brand)=>brand.isActive===true).map((brand)=>brand.brandId) :[];
  typesOfService: ServiceManagement[] =
  this.modalInformation.advisor ?
  this.modalInformation.advisor.services :this.modalInformation.workshop[0].services
 ;

  brands: ManagementBrand[] = this.modalInformation.advisor? this.modalInformation.advisor.brands: this.modalInformation.workshop[0].brands
  brandsForCreateAdvisor:brandCreate[] =[]

  ngOnInit(): void {
    //  console.log(this.modalInformation)
    if(this.modalInformation.advisor){
      let brands = this.modalInformation.workshop.filter((workshop)=>workshop.workshopId === this.modalInformation.advisor?.workshopId)
      this.brands= brands[0].brands.filter(br=> br.isActive === true);

       this.typesOfService = brands[0].services.filter(br=> br.isActive === true);

      this.typesOfService.forEach((service)=>{
        let serviceSelect = this.modalInformation.advisor.services.filter((Service)=> Service.serviceId === service.serviceId && Service.isActive === true)
        if(serviceSelect.length >0){
          service.isActive = true
        }
        else {
          service.isActive = false
        }
        })

    }
    if(this.helperService.user.role.roleId===2 && !this.modalInformation.advisor){
      this.typesOfService = this.typesOfService.filter(br=> br.isActive === true);
      this.typesOfService.forEach((service)=>{
        service.isActive = false;
      })
    }
    if(this.helperService.user.role.roleId===4&& !this.modalInformation.advisor){
      this.typesOfService =[]
      this.brands=[]
    }

    this.workshopSelected= this.modalInformation.advisor? this.modalInformation.advisor!.workshopId : 0

    this.brands.forEach((brand)=>{
      const newBrand = {
        brandId: brand.brandId,
        isActive: false,
      }
      this.brandsForCreateAdvisor.push(newBrand)
    })

  }
  onSwitchChange(service:ServiceManagement){
    service.isActive = !service.isActive

  }
  setCreationBrands(){

     this.brandsForCreateAdvisor.forEach((brand)=>{
       brand.isActive = false
      this.brandsSelected.forEach(brandSelected=> {
      if (brandSelected=== brand.brandId) {
        brand.isActive = true
      }

     })

     })
  }

  SelectWorkshop(workshop:number){
    this.brands=this.modalInformation.workshop[workshop].brands.filter(br=> br.isActive === true);
    this.typesOfService = this.modalInformation.workshop[workshop].services.filter(br=> br.isActive === true);
    this.typesOfService.forEach((service)=>{
      service.isActive = false;
    })
    this.brandsForCreateAdvisor = []
    this.brands.forEach((brand)=>{
      const newBrand = {
        brandId: brand.brandId,
        isActive: false,
      }
      this.brandsForCreateAdvisor.push(newBrand)
    })
  }

  // Check if the input contains characters that are not numbers (regular expression).
  onInput() {

    this.showError = !/^[0-9]*$/.test(this.phoneNumber);
  }

  //Validate that the form fields are not empty and that the field where the cell phone is located does not have letters.
  validationForm(){

    if (this.showError === true || this.advisorName === "" || this.phoneNumber === "" || this.brandsSelected.length === 0){
      return true
    }
    return false

  }

    onSave() {
      if(this.helperService.user.role.roleId===2){

        this.workshopSelected = this.modalInformation.workshop[0].workshopId
      }
      this.setCreationBrands()

      const services = this.typesOfService.map((service)=>{return {
        serviceId: service.serviceId,
        isActive: service.isActive
      }})
      const advisor:advisorDTO ={
        advisorId: this.modalInformation.advisor?this.modalInformation.advisor?.advisorId : 0 ,
        isActive: this.modalInformation.advisor? this.modalInformation.advisor?.isActive: true,
        workshopId : this.workshopSelected,

        advisorFullName: this.advisorName,
        phoneNumber: this.phoneNumber,
        brands: this.brandsForCreateAdvisor,
        services
      }
      if (this.modalInformation.advisor) {
        advisor.sapAdvisorId = this.modalInformation.advisor?.sapAdvisorId
      }


 this.ServiceAdvisorApi.post(advisor).subscribe({

  next: (response)=>{

    this.dialogRef.close();
    // ToastAdvisorEdit ToastAdvisorAdd

    if(response.message === "ServiceAdvisor Created Successfully") {
    const translateText = this.modalInformation.advisor?  this.translate.instant(
      'ToastAdvisorEdit',
      {
        fullName: this.advisorName
      }
    ):
    this.translate.instant(
      'ToastAdvisorAdd',
      {
        fullName: this.advisorName
      }
    )
      this.helperService.showAlert =true
      this.helperService.typeAlert ="success"
      this.helperService.messageAlert =translateText
      setTimeout(() => {
        this.helperService.showAlert =false
      }, 7000)
    }
  }, error: (err) => {

    // Validation 401 error
    if(err.status === 401){
      this.helperService.logoutToken()
    }

    this.dialogRef.close();
    if (err.error=== "Error Creating ServiceAdvisor.") {
      const translateTextError = this.translate.instant(
        'ToastAdvisorFail',
        {
          fullName: this.advisorName,
        }
      )
      this.helperService.showAlert =true
      this.helperService.typeAlert ="error"
      this.helperService.messageAlert =translateTextError
      setTimeout(() => {
        this.helperService.showAlert =false
      }, 7000)
    }
    // <insert code for what to do on failure>
}
 })

  }


  isClearDisabled(): boolean {
    // function to enable clear button conditionally
    let isDisabled = true;

    return isDisabled;
  }
}


